import {
  Component,
  Suspense,
  lazy,
  type ErrorInfo,
  type ReactNode,
} from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  error?: Error;
}

const CrashPage = lazy(
  () => import(/* webpackChunkName: "CrashPage" */ "../ErrorPages/CrashPage")
);

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("Error caught by error boundary:", error, errorInfo);
    import("../exceptionMonitoring")
      .then(({ trackException }) => {
        trackException(error, errorInfo);
      })
      .catch((e) => {
        console.error("Failed to track exception", e);
      });
  }

  render() {
    if (this.state.error) {
      return (
        <Suspense fallback={null}>
          <CrashPage error={this.state.error} />
        </Suspense>
      );
    }

    return this.props.children;
  }
}
